import { useNavigate, useParams } from 'react-router-dom';
import LessonForm from './components/LessonForm';

export default function EditLessonPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-8 md:px-6 md:py-10">
      <button
        type="button"
        onClick={() => navigate('/lessons')}
        className="flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-foreground-900 whitespace-nowrap"
      >
        <i className="ri-arrow-left-line"></i>
        수업일지 목록
      </button>

      <h1 className="mt-4 text-2xl font-bold text-foreground-950">수업일지 수정</h1>
      <p className="mt-1.5 text-sm text-foreground-600">
        기록된 수업 내용을 수정하고 테스트 범위·난이도·점수를 다시 입력할 수 있어요.
      </p>

      <div className="mt-6">
        {id ? (
          <LessonForm lessonId={id} onSaved={() => navigate('/lessons')} onCancel={() => navigate('/lessons')} />
        ) : (
          <p className="rounded-lg border border-dashed border-background-300 py-12 text-center text-sm text-foreground-500">
            수업일지를 찾을 수 없어요.
          </p>
        )}
      </div>
    </div>
  );
}